module.exports = __webpack_public_path__ + "static/media/aside_img_ex.59ae4f9f.jpg";